import additionalPriceInfo from './additional-price-info.vue.component.js';
import { defineComponent, onMounted, onBeforeUnmount, ref } from 'vue';
import { trackAbTestSeen, trackAbTestClicked } from '../tracking/trackingLayer.js';

const templateElement = document.getElementById('price-area-template');

export default defineComponent({
  template: templateElement ? templateElement.innerHTML : '',

  components: {
    additionalPriceInfo,
  },

  props: {
    displayPrice: {
      type: Object,
      required: true,
    },
    shippingCostCommunicationDecisionId: {
      type: String,
      required: false,
    },
  },

  setup(props) {
    const badgeSize = ref('large');
    let shippingCostCommunicationObserver: IntersectionObserver | null = null;
    const shippingCostCommunicationTestId = 'perso-ents-versandkostenkommunikation_detail_product';

    const handleResize = () => {
      badgeSize.value = window.innerWidth < 960 ? 'medium' : 'large';
    };

    function handleShippingCostCommunicationIntersection(entries: IntersectionObserverEntry[]) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          trackAbTestSeen(shippingCostCommunicationTestId, props.shippingCostCommunicationDecisionId as string);
          shippingCostCommunicationObserver?.disconnect();
        }
      });
    }

    onMounted(() => {
      handleResize();

      const shippingCostCommunicationElement = document.querySelector('[data-test-shipping-cost-communication]');
      if (shippingCostCommunicationElement && props.shippingCostCommunicationDecisionId) {
        shippingCostCommunicationObserver = new IntersectionObserver(handleShippingCostCommunicationIntersection);
        shippingCostCommunicationObserver.observe(shippingCostCommunicationElement);

        shippingCostCommunicationElement.addEventListener('click', () => {
          trackAbTestClicked(shippingCostCommunicationTestId, props.shippingCostCommunicationDecisionId as string);
        });
      }
      window.addEventListener('resize', handleResize);
    });

    onBeforeUnmount(() => {
      if (shippingCostCommunicationObserver) {
        shippingCostCommunicationObserver.disconnect();
      }
      window.removeEventListener('resize', handleResize);
    });

    return {
      badgeSize,
    };
  },
});
